import React from 'react';
import {noop} from 'lodash';

import DeltaListItem from '/component/base/DeltaListItem/DeltaListItem';

// Define the type for the item prop
interface EarningDeltaItemProps {
  item: {
    label: string;
    value: number;
    delta: number;
    period: string;
    testID: string;
  };
  onPress: () => void;
}

export const EarningDeltaItem: React.FC<EarningDeltaItemProps> = ({
  item: {label, value, delta, period, testID},
  onPress = noop,
}: EarningDeltaItemProps) => (
  <DeltaListItem
    readonly
    heading={label}
    headingUseCompetency={true}
    allowFontScaling
    maxFontSizeMultiplier={2}
    subheading={period}
    total={value}
    delta={delta}
    onPress={onPress}
    testID={testID}
  />
);

export default EarningDeltaItem;
